export const HTTP_CLIENT_KEY = "httpClient";
export const LOGIN_PLOC_KEY = "loginPLOC";
export const APP_PLOC_KEY = "appPLOC";
export const FACTORY_KEY = "Factory";
export const USERS_PLOC_KEY = "usersPLOC";
export const CALENDAR_PLOC_KEY = "calendarPLOC";
export const PERFORMANCES_PLOC_KEY = "performancesPLOC";
export const PIVOT_PLOC_KEY = "pivotPLOC";
export const NOTIFICAITONS_PLOC_KEY = "notificationsPLOCKey";
